/**
 * Timezone storage utilities
 * Manages user's timezone preference in localStorage
 */

const TIMEZONE_STORAGE_KEY = 'userTimezone'

/**
 * Get user's preferred timezone from localStorage
 * Falls back to browser timezone if not set
 * @returns {string} Timezone identifier (e.g., 'Asia/Bangkok')
 */
export const getUserTimezone = () => {
  const savedTimezone = localStorage.getItem(TIMEZONE_STORAGE_KEY)
  if (savedTimezone) {
    return savedTimezone
  }

  // Default to browser timezone
  return getBrowserTimezone()
}

/**
 * Get browser's timezone
 * @returns {string} Browser timezone identifier
 */
export const getBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (error) {
    // Fallback to Asia/Bangkok if browser doesn't support Intl API
    console.warn('Browser does not support Intl API, defaulting to Asia/Bangkok')
    return 'Asia/Bangkok'
  }
}

/**
 * Save user's timezone preference
 * @param {string} timezone - Timezone identifier
 */
export const saveUserTimezone = (timezone) => {
  localStorage.setItem(TIMEZONE_STORAGE_KEY, timezone)
}

/**
 * Clear saved timezone preference
 * Returns to browser default
 */
export const clearUserTimezone = () => {
  localStorage.removeItem(TIMEZONE_STORAGE_KEY)
}

/**
 * Check if user has a custom timezone set
 * @returns {boolean}
 */
export const hasCustomTimezone = () => {
  return localStorage.getItem(TIMEZONE_STORAGE_KEY) !== null
}
